import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  stepLoginSharedData: any;
  stepOneSharedData: any;
  stepTwoSharedData: any;
  stepThreeSharedData: any;
  stepFourSharedData: any;
  stepFiveSharedData: any;
  stepSixSharedData: any;

  stepThreeSharedDataPurchases: any; 
  stepFourSharedDataSales: any;


  completedStatusData: any;

  private dataSubject = new Subject<boolean>();

  sendData(data: boolean) {
    this.dataSubject.next(data);
  }

  getData() {
    return this.dataSubject.asObservable();
  }
  constructor() { }
}
